
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/redis",
      function () {
        return require("private-next-pages/destinations/redis.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/redis"])
      });
    }
  